import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { TrashIcon } from '../../../../assets/svg/iconos';
import { PeriodSelect } from './PeriodSelect';
import { TypeSelect } from './TypeSelect';

const timezone = process.env.REACT_APP_TIMEZONE;

const diasBtns = [
    { _id: '1', nombre: 'Lunes', abr: 'Lu', active: false },
    { _id: '2', nombre: 'Martes', abr: 'Ma', active: false },
    { _id: '3', nombre: 'Miércoles', abr: 'Mi', active: false },
    { _id: '4', nombre: 'Jueves', abr: 'Ju', active: false },
    { _id: '5', nombre: 'Viernes', abr: 'Vi', active: false },
    { _id: '6', nombre: 'Sábado', abr: 'Sa', active: false },
    { _id: '7', nombre: 'Domingo', abr: 'Do', active: false }
];

export const VacacionalItem = ({ editMode, descanso, descansosTemp, editDescanso, deleteVacaciones, onConvertToHorarioExtra, objProfesional, isHorarioExtra, editHorarioExtra, deleteHorarioExtra, horariosExtraTemp, onConvertToDescanso }) => {

    const { colores } = useSelector( state => state.ui );

    const [diasSemana, setDiasSemana] = useState(descanso.diasSemana || []);
    // eslint-disable-next-line no-unused-vars
    const [tipo, setTipo] = useState(descanso.tipo);

    useEffect(() => {
        setDiasSemana( descanso.diasSemana || [] );
        setTipo( descanso.tipo );
    }, [descanso]);

    useEffect(() => {
        if (editMode) {
            saveDiasSemana();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [diasSemana, editMode]);

    const clickRepeat = (id) => {
        if( editMode ){
            let newArray = [];
            if( diasSemana.includes(id) ){
                newArray = diasSemana.filter( item => item !== id );
            } else {
                newArray = [ ...diasSemana, id ];
            }
            newArray.sort((a, b) => { 
                return a - b; 
            })
            setDiasSemana( newArray );
        }
    }

    const saveChanges = ( horaInicio, horaFin ) => {
        if (isHorarioExtra && editHorarioExtra) {
            let newHorarioExtra = { 
                ...descanso,
                fechaInicio: moment.tz( horaInicio, timezone ).toISOString(),
                fechaFin: moment.tz( horaFin, timezone ).toISOString(),
                horaInicio: moment.tz( horaInicio, timezone ).toISOString(),
                horaFin: moment.tz( horaFin, timezone ).toISOString(),
                todaJornada: false,
            };
            editHorarioExtra( newHorarioExtra );
        } else {
            const fechaInicioMoment = moment.tz( horaInicio, timezone );
            const fechaFinMoment = moment.tz( horaFin, timezone );
            
            if (descanso.tipo === 'ausencia' && !fechaInicioMoment.isSame(fechaFinMoment, 'day')) {
                fechaFinMoment.year(fechaInicioMoment.year())
                             .month(fechaInicioMoment.month())
                             .date(fechaInicioMoment.date());
            }
            
            let newDescanso = { 
                ...descanso,
                fechaInicio: fechaInicioMoment.toISOString(),
                fechaFin: fechaFinMoment.toISOString(),
            };
            editDescanso( newDescanso );
        }
    }

    const saveDiasSemana = () => {
        if (!editMode) return;
        
        if (isHorarioExtra && editHorarioExtra) {
            let newHorarioExtra = { 
                ...descanso,
                diasSemana,
                repetir: diasSemana.length > 0
            };
            editHorarioExtra( newHorarioExtra );
        } else if (editDescanso) {
            let newDescanso = { 
                ...descanso,
                diasSemana,
                repetir: diasSemana.length > 0
            };
            editDescanso( newDescanso );
        }
    }
    
    const saveTipo = (tipo) => {
        if (isHorarioExtra && tipo !== 'horario_extra' && onConvertToDescanso) {
            onConvertToDescanso(descanso, tipo);
            return;
        }

        if (!isHorarioExtra && tipo === 'horario_extra' && onConvertToHorarioExtra) {
            onConvertToHorarioExtra(descanso);
            return;
        }

        if (!isHorarioExtra) {
            let fechaInicio = descanso.fechaInicio;
            let fechaFin = descanso.fechaFin;
            setTipo(tipo)

            if( tipo === 'ausencia'){
                fechaInicio = moment.tz(descanso.fechaInicio, timezone).hours(0).minutes(0).seconds(0).toISOString();
                fechaFin = moment.tz(descanso.fechaInicio, timezone).hours(23).minutes(59).seconds(0).toISOString();
            }

            const newDescanso = { 
                ...descanso,
                fechaInicio,
                fechaFin,
                tipo
            };
            editDescanso( newDescanso );
        }
    }

    return (
        <div
            style={{ backgroundColor: '#FAFAFA' }}
            className={`vacacional-item`}
        >
            <div className='item-tipology'>
                <div className='item-header'>Tipología</div>
                <div className='item-content'>
                    <TypeSelect
                        tipo={ descanso.tipo }
                        setTipo={ saveTipo }
                        editMode={ editMode }
                    />
                </div>
            </div>
            <div className='item-period'>
                <div className='item-header'>{isHorarioExtra ? 'Disponibilidad' : 'Ausencia'}</div>
                <div className='item-content'>
                    <PeriodSelect
                        editMode={ editMode }
                        descanso = { descanso }
                        saveChanges = { saveChanges }
                        objProfesional={ objProfesional }
                    />
                </div>
            </div>
            <div className='item-repeat'>
                <div className='item-header'>Repetición</div>
                <div className='item-content'>
                    <div className='repeat-selector'>
                        {
                            diasBtns.map( dia => (
                                <div 
                                    key={ `dia${ dia._id }`} 
                                    className={`repeat-item ${ diasSemana.includes(dia._id) ? 'active' : ''}`}
                                    style={{ 
                                        borderColor: colores.colorPrincipal,
                                    }}
                                    onClick={ () => clickRepeat(dia._id)}
                                >
                                    { dia.abr }
                                </div>
                            ))
                        }
                        
                    </div>
                </div>
            </div>
            <div 
                className='item-borrar'
                onClick={ () => {
                    if (isHorarioExtra && deleteHorarioExtra) {
                        deleteHorarioExtra( descanso );
                    } else {
                        deleteVacaciones( descanso );
                    }
                }}
            >
                <TrashIcon />
            </div>
        </div>
    )
}
